import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  Signal
} from "@angular/core";
import { FormService } from "src/app/services/form.service";
import { PriceService } from "src/app/services/price.service";
import { VehicleSearchResponse } from "src/domain/client";
import {
  EbuCarModelResponse,
  PackageResponse,
  PackageTagEnum,
  PackageTypeEnum,
  PriceTypeEnum,
  PropertyEnum
} from "src/domain/client";
import { Store } from "@ngrx/store";
import { selectSelectedEbuCar, selectCarInfo } from "src/app/state";

import { PricePipe } from "../../../pipes/sharedpipes/price.pipe";
import { ImageResolverPipe } from "../../../pipes/sharedpipes/image-resolver.pipe";
import { PriceDiffPipePipe } from "../../../pipes/price-diff-pipe.pipe";
import { FilterSubpackagesPipe } from "../../../pipes/filter-subpackages.pipe";
import { PackagePricePipe } from "../../../pipes/package-price.pipe";
import { CarSegmentKeyPipe } from "../../../pipes/car-segment-key.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { LowerCasePipe } from "@angular/common";

@Component({
  selector: "app-package-summary",
  templateUrl: "./package-summary.component.html",
  styleUrl: "./package-summary.component.scss",
  imports: [
    PricePipe,
    PriceDiffPipePipe,
    FilterSubpackagesPipe,
    PackagePricePipe,
    CarSegmentKeyPipe,
    TranslateModule,
    LowerCasePipe,
    ImageResolverPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageSummaryComponent implements OnInit {
  package = input<PackageResponse>();

  PackageTypeEnum = PackageTypeEnum;
  PackageTagEnum = PackageTagEnum;
  PriceTypeEnum = PriceTypeEnum;
  PropertyEnum = PropertyEnum;

  readonly mockEbuCarImageUrl =
    "https://pics.vwgroup.se/prod/TOP/small/Cykelhallare_Volkswagen_9299.jpg";

  readonly selectedEbuCar: Signal<EbuCarModelResponse | null>;
  readonly carInfo: Signal<VehicleSearchResponse | null>;

  constructor(
    public formService: FormService,
    public priceService: PriceService,
    private store: Store
  ) {
    this.selectedEbuCar = this.store.selectSignal(selectSelectedEbuCar);
    this.carInfo = this.store.selectSignal(selectCarInfo);
  }

  ngOnInit(): void {}

  // This should be changed during refactor step

  hasAllSelected(pkg: PackageResponse): boolean {
    if (pkg.type != PackageTypeEnum.OriginalService) return false;
    if (
      pkg.subPackages.filter((p) => !p.tags.includes(PackageTagEnum.Removable))
        .length >= pkg.subPackages.length
    )
      return true;
    return (
      !!pkg.subPackages.length &&
      this.formService.selectedBasePackages.find((j) => j.packageId === +pkg.id)
        .subPackageIds.length ===
        pkg.subPackages.length - 1
    );
  }
}
